const card = {
  MuiCardMedia: {
    styleOverrides: {
      root: {
        height: 130,

        '@media (min-width: 900px)': {
          height: 176,
        },
      },
    },
  },
};

export default card;
